import React from 'react'
import Logo from '../../img/logo_white.png'
import { Link } from "react-router-dom"
import Button from '../../components/Button'

const navigationBar = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '10vh',
    backgroundColor: '#0a1a35',
    color: 'white',
    paddingLeft: '40px',
    paddingRight: '40px',
  }
  
  

export default function PageHeader() {
    return (
        <div style={navigationBar}>
        <div style={{ marginRight: '30px' }}>
            <img src={Logo} height='60px' width='60px' alt='logo.png' />
        </div>
        <Link to={'/cm'} style={{ textDecoration: 'none' }}>
            <Button text='Home' handleClick={() => null} curPage={window.location.href === '/cm'} />
        </Link>
        <Link to={'/cm/team'} style={{ textDecoration: 'none' }}>
            <Button text='Our Team' handleClick={() => null } curPage={window.location.href === '/cm/team'} />
        </Link>
        </div>
      );
}